import { CONTENT_TYPE, HTTP_HEADERS } from '@core/constants/apiService.constant';

const errorResponseCreator = (
  error = {
    error: 'An unexpected error occurred.',
    message: 'An unexpected stream from the server.',
    statusCode: 500
  }
) => {
  return new Response(JSON.stringify(error), {
    status: 500,
    headers: { [HTTP_HEADERS.ContentType]: CONTENT_TYPE.JSON }
  });
};

export { errorResponseCreator };
